const resetPasswordFormStyles = {
  formWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 15,
  },
}

export default resetPasswordFormStyles
